module.exports = __webpack_public_path__ + "img/flecha-enter.b63c2677.svg";